import { call, select } from 'redux-saga/effects';
import { User, UserId } from 'features/users/types';
import { notification } from 'features/notifications/toast/notification';
import i18n from 'i18n';
import { selectLocalUserId, selectUserById } from 'features/users/usersSlice';
import { logger } from 'utils/logger';
import { signalingPresentContentAllowed } from 'features/permissions/actions';

export function* onPresentContentAllowedSaga({
  payload,
}: ReturnType<typeof signalingPresentContentAllowed>) {
  const { data, initiator } = payload;

  const localUserId: UserId = yield select(selectLocalUserId);

  for (const id of data.users) {
    if (localUserId === id) {
      logger
        .remote({ tier: 1 })
        .info(`The user was allowed to present content by user id=${initiator.id}`);

      const initiatorUser: User | undefined = yield select(selectUserById, initiator.id);

      if (initiatorUser?.name) {
        yield call(
          notification,
          i18n.t('notifications:present_content_allowed', { username: initiatorUser.name })
        );
      } else {
        yield call(notification, i18n.t('notifications:present_content_allowed_unnamed'));
      }
    }
  }
}
